module["exports"] = [
  "GmbH",
  "AG",
  "Gruppe",
  "KG",
  "GmbH & Co. KG",
  "UG",
  "OHG"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de/company/legal_form.js
// module id = 937
// module chunks = 0